import MobileDetect from "mobile-detect";

const maybeWindow = typeof window !== "undefined" ? window : undefined;
export const md = new MobileDetect(maybeWindow?.navigator.userAgent ?? "");
